import React from 'react'
import { useTheme } from '@mui/material'
import FooterWrapper from 'redesign/components/atoms/footer-wrapper'
import Dialog from 'redesign/components/molecules/dialog'
import Drawer from '../Drawer'
import { ContentContainer, ContentDesktopContainer, FooterContainer } from './styles'
import type { DrawerModalProps } from './types'

const DrawerModal: React.FC<DrawerModalProps> = ({
  children,
  isOpen,
  onClose,
  isSmallScreen,
  header,
  footer,
  noPadding,
  dialogSize,
  isHeightFixed = false,
  customZIndex,
  fullHeight,
  showPuller,
  backgroundColor,
}) => {
  const { palette } = useTheme()

  if (isSmallScreen) {
    return (
      <Drawer
        open={isOpen}
        onClose={onClose}
        header={header}
        backgroundColor={backgroundColor ?? palette.background.base}
        footer={footer}
        customZIndex={customZIndex}
        fullHeight={fullHeight}
        showPuller={showPuller}
      >
        <ContentContainer>{children}</ContentContainer>
      </Drawer>
    )
  }

  return (
    <Dialog
      addMinWidth
      open={isOpen}
      onClose={onClose}
      noPadding={noPadding}
      size={dialogSize}
      isHeightFixed={isHeightFixed}
      customZIndex={customZIndex}
    >
      {header}
      <ContentDesktopContainer>{children}</ContentDesktopContainer>
      {Boolean(footer) && (
        <FooterWrapper>
          <FooterContainer extraBottomPadding>{footer}</FooterContainer>
        </FooterWrapper>
      )}
    </Dialog>
  )
}

export default DrawerModal
